import intl from 'react-intl-universal';
import { IconButton, Tooltip } from '@getsynapse/design-system';
import { getStatusColumn } from 'Pages/ProjectsListPage/helpers/tableColumnsValues';
import { useHistory } from 'react-router-dom';
import { PATHS } from 'utils/constants';
import { setSidePanelUpdatedData } from 'state/SidePanel/sidePanelSlice';
import { useDispatch } from 'react-redux';
import { TaskDetailType } from 'utils/customTypes';

interface TaskSidePanelHeaderProps {
  onClose: () => void;
  projectId?: string;
  taskData: TaskDetailType;
  updatedData: TaskDetailType;
}

const TaskSidePanelHeader: React.FC<TaskSidePanelHeaderProps> = ({
  onClose,
  projectId,
  updatedData,
  taskData,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const onFullView = () => {
    const { assignedUsers = [] } = updatedData;
    const ownersIds = assignedUsers?.map((owner: any) => owner.id || owner);
    dispatch(
      setSidePanelUpdatedData({
        ...updatedData,
        assignedUsers: ownersIds,
      })
    );
    history.push(
      `${PATHS.PROJECT_PAGE}/${projectId}/tasks/${taskData.id}?fromSidePanel=true`,
      {
        from: history.location.pathname,
      }
    );
    onClose();
  };

  return (
    <div className='flex items-center mr-3'>
      <div className='ml-2 flex-grow'>{getStatusColumn(taskData.status)}</div>

      <Tooltip
        openMode='hover1'
        timeout={0}
        position='botomCenter'
        contentProps={{ className: 'px-3 py-2 text-sm z-50' }}
        trigger={
          <IconButton
            name='resize'
            iconClassname='pointer-events-none'
            className='text-lg p-1 rounded text-primary-dark hover:bg-neutral-lightest hover:shadow-allocation-table'
            onClick={onFullView}
          />
        }
      >
        {intl.get('SIDE_PANEL.FULL_PAGE')}
      </Tooltip>
    </div>
  );
};

export default TaskSidePanelHeader;
